/*
  Auto-loading pagination. Wraps the page-number nav rendered by
  snippets/pagination.liquid; when the nav scrolls near the viewport it
  fetches the next page (same section, via ?section_id=), appends the new
  cards to #product-grid and swaps itself for the fetched nav. With no
  next page it removes itself. The page links underneath stay usable if
  JS is off or a fetch fails. Filters replace the whole grid container,
  which inserts a fresh element, so it re-arms itself with no wiring.
*/
class LoadMorePages extends HTMLElement {
  connectedCallback() {
    this.next = this.dataset.next;
    if (!this.next || !('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.load();
      },
      { rootMargin: '0px 0px 600px 0px' },
    );
    this.io.observe(this);
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
  }

  load() {
    if (this.loading) return;
    this.loading = true;
    this.io.disconnect();
    this.classList.add('is-loading');

    const url = new URL(this.next, window.location.origin);
    url.searchParams.set('section_id', this.dataset.section);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`load-more-pages: ${response.status} for ${url}`);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = document.getElementById('product-grid');
        const fetchedGrid = doc.getElementById('product-grid');
        if (!grid || !fetchedGrid) throw new Error('load-more-pages: #product-grid missing');
        grid.append(...fetchedGrid.children);
        const fetchedLoader = doc.querySelector('load-more-pages');
        if (fetchedLoader && fetchedLoader.dataset.next) {
          this.replaceWith(fetchedLoader);
        } else {
          this.remove(); // every page is on screen now; a page list would be stale
        }
      })
      .catch((error) => {
        console.error(error);
        this.classList.remove('is-loading');
        this.loading = false;
      });
  }
}

if (!customElements.get('load-more-pages')) customElements.define('load-more-pages', LoadMorePages);
